import MediaQuery from 'react-responsive';
import Wave2 from '../components/waves/wave2';
import Wave3 from '../components/waves/wave3';
import Key4 from '../components/keys/key4';
import Key3Mobile from '../components/keys/key3mobile';

function ComeExperience({animate}) {
   return(
      <>
         <div className=" come-experience bg-sand wave wave--top">
            <Wave2/>
            <div className="flex flex--equal">
               <div class="col-full"><h2>Come and experience The Miller Difference</h2></div>
               <div class="col-1/3 bucket"><p>We can’t wait to welcome you to one of our developments. Book an appointment to visit us online, or over the phone. We can even show you around virtually if you’d prefer.</p></div>
               <div class="col-1/3 bucket"><p>Meet our Development Sales Managers who will give you all the details of the homes that may interest you and answer any questions you may have.</p></div>
               <div class="col-1/3 bucket"><p>You can look around our amazing show homes, see for yourself the quality of the build and be inspired by the many options you have for fixtures and finishes. Can you imagine living in a brand-new home?</p></div>
            </div>
            <MediaQuery minWidth={768}>
               <Key4 animate={animate}/>
               <Wave3/>
            </MediaQuery>
         </div>
         <MediaQuery maxWidth={767}>
            <Key3Mobile animate={animate}/>
         </MediaQuery>
      </>
   )
}

export default ComeExperience;